import styled from 'styled-components';

const TableButton = styled.button`
  position: relative;
  height: 80px;
  background-color: ${({ open, theme }) =>
    open ? theme.colors.warning : theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  border-radius: ${({theme})=>theme.radii.xl};
  border: 4px solid ${({theme})=>theme.colors.background};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
  }
`;

export default TableButton;